import { render, staticRenderFns } from "./DeleteAgreement.vue?vue&type=template&id=43241543&"
import script from "./DeleteAgreement.vue?vue&type=script&lang=js&"
export * from "./DeleteAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports